<template>
  <div class="drag-container">
    <div class="drag-header">
      <div class="time-zone-container">
        <div class="time-zone-text">Time Zone</div>
        <div class="select-container">
          <select v-model="$parent.zone">
            <option v-for="item in timezones" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
          <div class="select-down-icon"></div>
        </div>
      </div>
    </div>
    <div class="drag-page">
      <div class="main-drag-container">
        <div class="phone-container">
          <div class="username-container">{{ currentPublisher.username }}</div>
          <div class="ins-info">
            <div
              class="ins-img"
              :key="currentPublisher.image"
              v-lazy:background-image="currentPublisher.image"
            ></div>
            <div class="type-list-container">
              <div class="ins-type-container">
                <div class="type-text">{{ currentPublisher.postCount }}</div>
                <div class="type-num">posts</div>
              </div>
              <div class="ins-type-container">
                <div class="type-text">
                  {{ currentPublisher.followerCount }}
                </div>
                <div class="type-num">followers</div>
              </div>
              <div class="ins-type-container">
                <div class="type-text">
                  {{ currentPublisher.followingCount }}
                </div>
                <div class="type-num">following</div>
              </div>
            </div>
          </div>
          <div class="scroller-view" id="drag-list">
            <div class="bubble" v-if="showFirstDrag">
              <div class="arrow-up"></div>
              <div>Hold to drag & drop media.<br />Tap to schedule media.</div>
              <div class="right-container">
                <div class="del-icon" @click.stop="closeFirstDragBubble"></div>
              </div>
            </div>
            <draggable
              v-model="uploadMediaList"
              :options="dragOptions"
              :move="onMoveCallback"
              ref="scrollView"
              id="drag"
              class="media-list"
            >
              <div
                @click="open(media)"
                class="media-item"
                :key="media.coverUrl + media.id"
                v-lazy:background-image="media.coverUrl"
                v-for="media in list"
                :class="{
                  schedule: media.from === 'edit' || media.from === 'instagram',
                  add: media.from === 'add',
                  instagram: media.from === 'instagram',
                }"
              >
                <div v-if="media.loading" class="media-loading-container"></div>
                <div
                  v-if="media.type === 2 || media.media_type === 2"
                  class="video-icon"
                ></div>
                <div
                  class="del-btn"
                  v-show="media.from !== 'instagram'"
                  @click.stop="del(media)"
                ></div>
                <div
                  class="move-icon"
                  @click.stop=""
                  v-show="media.from === 'add'"
                ></div>
                <div class="ins-icon" v-show="media.from === 'instagram'"></div>
                <div class="time-container" v-if="media.shortTime">
                  {{ media.shortTime }}
                </div>
                <div
                  class="mul-icon"
                  v-if="media.images && media.images.length > 1"
                ></div>
                <div
                  class="mul-icon"
                  v-if="media.medias && media.medias.length > 1"
                ></div>
              </div>
              <div v-show="loading" class="loading-container" slot="footer">
                <i class="el-icon-loading"></i>
              </div>
              <div
                v-show="!loading && showInstagram && end"
                class="loading-container"
                style="color: gray; font-size: 13px"
                slot="footer"
              >
                Only display recent 12 posts from instagram
              </div>
            </draggable>
          </div>
          <div class="show-ins">
            <span class="title">Show Instagram</span>
            <el-switch v-model="showInstagram"> </el-switch>
          </div>
          <div @click="reload()" class="refresh-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import {
  DRAG_DROP_PUBLISHER_LIST,
  CURRENT_PUBLISHER_ID,
  FIRST_DRAG,
  CURRENT_PUBLISHER_SIMPLE,
  TIMEZONE,
  CURRENT_USER_INFO_SIMPLE,
} from "../../store/mutation-types";
import { mapGetters } from "vuex";
import { getScheduleList, delPost } from "../../service/post";
import { showErrorMsg } from "../../utils/errors";
import moment from "moment-timezone";
import { getInsMedias } from "../../service/instagram";
import {
  getPublisherInfo,
  getCurrentPublisherInfo,
} from "../../service/publisher";
import { Post } from "../../service/model/post";
import { timezones } from "../../const/timezone";

export default {
  name: "DragPage",
  components: {
    draggable,
  },
  computed: {
    ...mapGetters({
      publisherId: CURRENT_PUBLISHER_ID,
      dragDropList: DRAG_DROP_PUBLISHER_LIST,
      firstDrag: FIRST_DRAG,
      timezone: TIMEZONE,
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 显示第一次drag提示
     */
    showFirstDrag() {
      if (this.firstDrag) {
        const addList = this.uploadMediaList.filter((u) => u.from === "add");
        return addList.length > 0;
      }
      return false;
    },
    /**
     * 计算列表
     */
    list() {
      const addList = this.uploadMediaList.filter((u) => u.from === "add");
      const editList = this.uploadMediaList.filter((u) => u.from === "edit");
      const insList = this.uploadMediaList.filter(
        (u) => u.from === "instagram"
      );
      editList.sort((e1, e2) => {
        return moment(e1.post_time).isBefore(moment(e2.post_time)) ? 1 : -1;
      });
      let result;
      if (this.showInstagram && this.end) {
        result = [...addList, ...editList, ...insList];
      } else {
        result = [...addList, ...editList];
      }
      result.forEach((m) => {
        if (m.shortTime) {
          m.shortTime = moment
            .tz(m.post_time, this.timezone)
            .format("MMM DD, HH:mm");
        }
        // 计算当前图片是否在loading状态
        const loadingIndex = this.loadingList.findIndex((l) => l === m.id);
        m.loading = loadingIndex !== -1;
      });
      result = result.filter((r) => r.media_type !== 3);
      return result;
    },
  },
  data() {
    return {
      timezones,
      zone: "",
      loading: false,
      end: false,
      showInstagram: false,
      formType: "", // 添加post的类型
      offset: 0, // schedule的数据的偏移量
      currentPublisher: {},
      uploadMediaList: [],
      mediaDragOptions: {
        group: { name: "media", revertClone: true, pull: "clone" },
        sort: false,
        forceFallback: true,
        fallbackClass: "media-item",
      },
      dragOptions: {
        group: { name: "media" },
        filter: ".schedule",
        preventOnFilter: false,
        forceFallback: true,
        handle: ".move-icon",
      },
      loadingList: [], // add正在loading的media id
    };
  },
  methods: {
    /**
     * 关闭drag的提示
     */
    closeFirstDragBubble() {
      this.$store.commit(FIRST_DRAG, false);
    },
    /**
     * 数据成功回调
     */
    postSuccess(data) {
      if (data === undefined) {
        return;
      }
      // 判断如果是修改就替换对应项，如果是添加则添加
      let currentPublisherPostIndex = data.findIndex(
        (u) => u.publisherId === this.publisherId
      );
      if (currentPublisherPostIndex === -1) {
        currentPublisherPostIndex = 0;
      }
      // 查找对应项，找到则说明是修改，直接进行替换，没找到则说明是添加
      data[currentPublisherPostIndex].items.forEach((post) => {
        // 找到则说明是修改
        let historyIndex = this.uploadMediaList.findIndex(
          (u) => u.id === post.id
        );
        if (historyIndex !== -1) {
          this.$set(this.uploadMediaList, historyIndex, post);
          console.log(
            "uploadMediaList[0]",
            this.uploadMediaList[0],
            this.uploadMediaList.length
          );
        } else {
          // 只有当post的时候才会添加
          if (post.media_type !== 3) {
            this.uploadMediaList.push(post);
          }
        }
      });
    },
    /**
     * 删除对应数据
     */
    async del(media) {
      if (media.from === "edit") {
        // 弹出删除确认提示
        await this.$confirm.show({
          text: "Delete the schedule?",
          yesText: "OK",
        });
        const loading = this.$loading();
        try {
          await delPost({ id: media.id });
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
      const delIndex = this.uploadMediaList.findIndex((u) => u.id === media.id);
      console.log("delIndex", delIndex);
      this.uploadMediaList.splice(delIndex, 1);
    },
    /**
     * 验证是否可以被移动
     */
    onMoveCallback(evt) {
      if (evt.to.id !== "drag") {
        return false;
      }
      // 当一项都没有的时候可以添加
      if (this.list.length === 0) {
        return true;
      }
      // 当添加项在首尾的时候可以添加 willInsertAfter指代是插入对应索引的前面还是后面(如果插入第二个位置index也是0，但是willInsertAfter = true)
      if (evt.relatedContext.index === 0 && !evt.willInsertAfter) {
        return true;
      }
      if (!evt.relatedContext.element) {
        return false;
      }
      return evt.relatedContext.element.from === "add";
    },
    /**
     * 打开对应表单，如果是拖拽进入则添加，如果是存在则是修改，如果是ins则无效果
     * @param media
     */
    open(media) {
      // ins 和 正在加载的图片点击无效
      if (media.from === "instagram" || media.loading) {
        return;
      }
      if (media.form) {
        // 有form说明是通过saved添加,则弹出saved对应页面
        this.$bus.$emit("showRepostDetail", media);
        return;
      }
      // 拼接表单
      let scheduleForm = {
        images: [media],
        id: media.id,
        type: "new",
        form: {},
        mediaType: 1,
        fromType: media.fromType,
        tempForm: media.tempForm,
      };
      if (media.from === "edit") {
        const postInfo = new Post(media);
        scheduleForm = {
          images: postInfo.images,
          type: "edit",
          id: media.id,
          form: postInfo.form,
          mediaType: postInfo.mediaType,
        };
      }
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    /**
     * 加载schedule数据
     * @param reload 是否重新加载
     * @returns {Promise<void>}
     */
    async loadScheduleList({ reload }) {
      if (this.$store.getters[CURRENT_PUBLISHER_SIMPLE] === null) {
        return;
      }
      // 显示Loading
      try {
        this.loading = true;
        let currentDragInfo = this.dragDropList[this.publisherId];
        // 重新加载则重置列表以及列表偏移量
        if (reload) {
          this.uploadMediaList = currentDragInfo.uploadMediaList;
          this.offset = 0;
          this.end = false;
        }
        const schedule = await getScheduleList({
          reverse: true,
          offset: this.offset,
        });
        // 刨去重复项
        console.log("重新加载了");
        const scheduleList = schedule.results.filter(
          (s) => this.uploadMediaList.findIndex((u) => u.id === s.id) === -1
        );
        this.uploadMediaList = [...this.uploadMediaList, ...scheduleList];
        // 如果没有更多则无需再触发加载
        if (schedule.next === null) {
          this.end = true;
        }
        this.offset += 15;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
      }
      await this.validateScroller();
    },
    /**
     * 更新publisher对应的drag信息
     */
    updateDragList() {
      this.dragDropList[this.publisherId] = {
        showInstagram: this.showInstagram,
        uploadMediaList: this.uploadMediaList.filter((m) => m.from === "add"),
      };
      this.$store.commit(DRAG_DROP_PUBLISHER_LIST, this.dragDropList);
    },
    async validateScroller() {
      if (!this.currentPublisher || this.$route.query.type !== "drag") {
        return;
      }
      const scrollerView = document.getElementById("drag-list");
      const h = scrollerView.clientHeight; // div可视区域的高度
      const sh = scrollerView.scrollHeight; // 滚动的高度，$(this)指代jQuery对象，而$(this)[0]指代的是dom节点
      const st = scrollerView.scrollTop; // 滚动条的高度，即滚动条的当前位置到div顶部的距离
      if (h + st >= sh - 20) {
        // 只有加载已完成且没到底才能继续加载
        if (!this.loading && !this.end) {
          // 上面的代码是判断滚动条滑到底部的代码
          await this.loadScheduleList({ reload: false });
        }
      }
    },
    /**
     * 展示post的详细信息
     */
    showPostDetail(item) {
      this.$refs.postDetail.show(item);
    },
    async reload() {
      if (this.$store.getters[CURRENT_PUBLISHER_SIMPLE] === null) {
        return;
      }
      // 显示Loading
      const loading = this.$loading({
        target: "#drag-list",
      });
      try {
        // 先获取历史添加的drag数据
        let currentDragInfo = this.dragDropList[this.publisherId];
        // 如果存在则还原历史记录
        if (!currentDragInfo) {
          currentDragInfo = this.dragDropList[this.publisherId] = {
            showInstagram: true,
            uploadMediaList: [],
          };
        }
        this.showInstagram = currentDragInfo.showInstagram;
        this.uploadMediaList = currentDragInfo.uploadMediaList;
        this.updateDragList();
        // 获取最近12条post数据
        await this.loadScheduleList({ reload: true });
        // 同时获取最近的12条ins记录
        const insList = await getInsMedias({});
        this.uploadMediaList.push(...insList.medias.slice(0, 12));
        const publisher = await getCurrentPublisherInfo();
        this.currentPublisher = await getPublisherInfo();
        this.currentPublisher.postCount = publisher.media_count;
        this.currentPublisher.followerCount = publisher.followers_count;
        this.currentPublisher.followingCount = publisher.follows_count;
        console.log("publisher111111111111111", publisher);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  watch: {
    publisherId: {
      async handler(val, old) {
        // 如果切换到非ins类型则返回首页
        const currentPublisher = this.user.linkedInstagramList.find(
          (l) => l.publisherId === val
        );
        const oldPublisher = this.user.linkedInstagramList.find(
          (l) => l.publisherId === old
        );
        if (
          oldPublisher &&
          currentPublisher.socialNetwork !== oldPublisher.socialNetwork
        ) {
          this.$router.push({ name: "SchedulePage" });
        } else {
          if (this.$route.query.type === "drag") {
            this.reload();
          }
        }
      },
      immediate: true,
    },
    uploadMediaList: {
      handler() {
        this.updateDragList();
      },
      deep: true,
    },
    showInstagram() {
      this.updateDragList();
    },
    "$route.query"(val, old) {
      if (!this.currentPublisher) {
        return;
      }
      this.$nextTick(() => {
        // 如果是从别的页面切到schedule的则刷新
        if (old.type !== "drag" && val.type === "drag") {
          this.reload();
        }
      });
    },
  },
  mounted() {
    const scrollerView = document.getElementById("drag-list");
    scrollerView.addEventListener("scroll", () => {
      if (this.$route.query.type === "drag") {
        this.$nextTick(() => {
          this.validateScroller();
        });
      }
    });
  },
  created() {
    /**
     * schedule上传成功回调
     */
    this.$bus.$on("scheduleSuccess", (data, info) => {
      console.log("info", info);
      this.postSuccess(data);
      if (info.type === "saved") {
        // 删除原来add状态的图片
        let addIndex = this.uploadMediaList.findIndex((u) => u.id === info.id);
        if (addIndex !== -1) {
          this.uploadMediaList.splice(addIndex, 1);
        }
      }
      // 从loading列表中删除
      const delLoadingIndex = this.loadingList.findIndex((l) => l === info.id);
      if (delLoadingIndex !== -1) {
        this.loadingList.splice(delLoadingIndex, 1);
      }
    });
    this.$bus.$on("uploadCallback", ({ info }) => {
      let addIndex = this.uploadMediaList.findIndex((u) => u.id === info.id);
      if (addIndex !== -1) {
        // 如果schedule点击确认则清空之前拖拽的项
        if (info.type === "new" || info.type === "saved") {
          this.$set(this.uploadMediaList, addIndex, info);
          this.loadingList.push(info.id);
        }
      }
    });
  },
};
</script>
<style lang="less">
.drag-page .media-list {
  &:hover .media-item {
    .video-icon,
    .del-btn,
    .move-icon,
    .time-container {
      display: block;
    }
  }

  .media-item {
    width: 121px;
    height: 121px;
    margin: 0.5px;
    background-size: cover;
    background-position: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .mul-icon {
      background-image: url("../../../public/images/library/album@3x.png");
      width: 20px;
      height: 20px;
      background-size: contain;
      background-position: center;
      position: absolute;
      right: 5px;
      top: 5px;
    }

    &.schedule {
      cursor: pointer;
    }

    &.instagram {
      cursor: default;
    }

    &.add {
      cursor: pointer;
    }

    .video-icon {
      width: 55px;
      height: 55px;
      z-index: 2;
      background-size: cover;
      background-image: url("../../../public/images/schedule_posts/list/video.png");
      position: absolute;
      top: 38px;
      right: 27px;
      display: none;
    }

    .duration,
    .media-info {
      display: none;
    }
    .media-loading-container {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.7);
      z-index: 3;
    }
    .del-btn {
      position: absolute;
      left: 4px;
      top: 3px;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url("../../../public/images/d&d/Delete@3x.png");
      cursor: pointer;
      display: none;

      &:hover,
      &:active {
        opacity: 0.7;
      }
    }

    .move-icon {
      position: absolute;
      right: 3px;
      bottom: 3px;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url("../../../public/images/d&d/Move@3x.png");
      display: none;
      cursor: move;
    }

    .ins-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 35px;
      height: 35px;
      background-size: contain;
      background-image: url("../../../public/images/d&d/Instagram@3x.png");
    }

    .time-container {
      width: 100px;
      height: 20px;
      background-color: #323232;
      border-radius: 2px;
      position: absolute;
      bottom: 6px;
      line-height: 20px;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 10px;
      display: none;
      text-align: center;
    }
  }
}
</style>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.drag-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  .drag-header {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #eceff1;

    .time-zone-container {
      display: flex;
      align-items: center;
      position: fixed;
      top: 90px;
      right: 0;

      .select-container {
        -webkit-appearance: none;
        background-color: #fff;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 30px;
        outline: 0;
        padding: 0 8px;
        margin-right: 25px;
        position: relative;

        select {
          border: 0;
          background: transparent;
          width: 150px;
          height: 100%;
          cursor: pointer;
          -webkit-appearance: none;
          font-size: 13px;
        }

        .select-down-icon {
          width: 13px;
          height: 13px;
          background-position: center;
          background-size: contain;
          background-image: url("../../../public/images/common/down_icon@3x.png");
          background-repeat: no-repeat;
          position: absolute;
          right: 10px;
          top: 8px;
        }
      }

      .time-zone-text {
        margin-right: 20px;
      }
    }
  }

  .drag-page {
    padding: 0 40px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    flex: 1;

    .main-drag-container {
      flex: 1;
      min-height: 800px;
      align-items: center;
      justify-content: center;
      display: flex;
      padding: 23px 0;
      margin-top: 20px;

      .phone-container {
        width: 394px;
        height: 787px;
        position: relative;
        display: flex;
        flex-direction: column;
        background-image: url("../../../public/images/d&d/iphone.png");
        background-size: contain;
        padding: 35px 13px 65px 13px;

        .username-container {
          font-size: 16px;
          width: 164px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          position: absolute;
          left: 114px;
          top: 13px;
        }

        .show-ins {
          position: absolute;
          right: 30px;
          bottom: 24px;

          .title {
            margin-right: 13px;
            font-size: 16px;
          }
        }

        .refresh-icon {
          height: 28px;
          width: 28px;
          background-size: contain;
          background-image: url("../../../public/images/d&d/refresh.png");
          position: absolute;
          left: 40px;
          bottom: 20px;
          cursor: pointer;

          &:hover,
          &:active {
            opacity: 0.7;
          }
        }

        .ins-info {
          height: 60px;
          display: flex;
          align-items: center;
          padding: 0 10px;

          .type-list-container {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-around;

            .ins-type-container {
              text-align: center;

              .type-text {
                font-size: 16px;
              }

              .type-num {
                color: @font-color-gray;
                font-size: 10px;
              }
            }
          }

          .ins-img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background-size: contain;
          }
        }

        .bubble {
          padding: 7px;
          background: @theme-color;
          position: absolute;
          top: 50px;
          left: 40px;
          font-size: 13px;
          color: white;
          border: 4px;
          z-index: 100;
          text-align: center;
          border-radius: 4px;
          display: flex;

          .arrow-up {
            width: 0;
            height: 0;
            border-left: 8px solid transparent; /* 右透明 */
            border-right: 8px solid transparent; /*右透明 */
            border-bottom: 8px solid @theme-color; /* 定义底部颜色 */
            font-size: 0;
            line-height: 0;
            position: absolute;
            top: -6px;
            left: 30px;
          }

          .right-container {
            padding-left: 7px;
            display: flex;
            align-items: center;
            justify-content: center;

            .del-icon {
              background-image: url("../../../public/images/d&d/Remove.png");
              width: 15px;
              height: 15px;
              cursor: pointer;
              background-size: contain;

              &:hover,
              &:active {
                opacity: 0.7;
              }
            }
          }
        }

        .scroller-view {
          flex: 1;
          overflow-y: overlay;
          overflow-x: hidden;
          position: relative;

          .media-list {
            font-size: 0;
            padding-left: 0.5px;

            .loading-container {
              height: 40px;
              text-align: center;
              font-size: 20px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
